/**
 * ActionButton (P26).
 *
 * Lifted from `sample-wireframe/client/src/pages/Home.tsx`. `.action-button`
 * + `.primary` + `.danger` classes are in `apps/web/src/styles/index.css`.
 * Always pair with a Lucide icon for a uniform visual rhythm.
 */
import type { JSX, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils.js';

interface ActionButtonProps {
  children: ReactNode;
  icon?: LucideIcon;
  primary?: boolean;
  danger?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export function ActionButton({
  children,
  icon: Icon,
  primary,
  danger,
  onClick,
  type = 'button',
  disabled,
}: ActionButtonProps): JSX.Element {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn('action-button', primary && 'primary', danger && 'danger')}
    >
      {Icon ? <Icon size={15} aria-hidden /> : null}
      {children}
    </button>
  );
}
